/**
 * Centre Page — Basics & Beyond accordion (one panel open at a time).
 */
(function () {
	'use strict';

	function closeItem(item) {
		if (!item) {
			return;
		}
		item.classList.remove('expanded');
		var btn = item.querySelector('[data-basics-beyond-toggle]');
		var detailId = btn ? btn.getAttribute('aria-controls') : '';
		var detail = detailId ? document.getElementById(detailId) : null;
		if (btn) {
			btn.setAttribute('aria-expanded', 'false');
		}
		if (detail) {
			detail.setAttribute('hidden', '');
		}
	}

	function openItem(item) {
		if (!item) {
			return;
		}
		var btn = item.querySelector('[data-basics-beyond-toggle]');
		var detailId = btn ? btn.getAttribute('aria-controls') : '';
		var detail = detailId ? document.getElementById(detailId) : null;
		if (!btn || !detail) {
			return;
		}
		item.classList.add('expanded');
		btn.setAttribute('aria-expanded', 'true');
		detail.removeAttribute('hidden');
	}

	function init() {
		var section = document.querySelector('[data-centre-basics-beyond]');
		if (!section) {
			return;
		}

		section.querySelectorAll('[data-basics-beyond-toggle]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var item = btn.closest('[data-basics-beyond-item]');
				if (!item) {
					return;
				}

				var isExpanded = item.classList.contains('expanded');

				// Close every other panel in this section first.
				section.querySelectorAll('[data-basics-beyond-item]').forEach(function (other) {
					if (other !== item) {
						closeItem(other);
					}
				});

				if (isExpanded) {
					closeItem(item);
				} else {
					openItem(item);
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
